import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const timelineBlocks = document.querySelectorAll(".timeline-block");

  timelineBlocks.forEach((timelineBlock) => {
    const timeline = timelineBlock.querySelector(".timeline");
    const bgLine = timeline?.querySelector(".timeline__bg-line");
    const timelineItems = timelineBlock.querySelectorAll(".timeline__item");

    if (bgLine) {
      gsap.set(bgLine, { height: 0, opacity: 0.5 });

      gsap.to(bgLine, {
        height: "100%",
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: timeline,
          start: "top 80%",
          end: "bottom 20%",
          scrub: 1,
        },
      });
    }

    timelineItems.forEach((item, index) => {
      const card = item.querySelector(".timeline-card");
      const line = item.querySelector(".timeline-bullet__line");
      const bullet = item.querySelector(".timeline-bullet__bullet");

      gsap.set(card, { opacity: 0, y: 80 });
      gsap.set(line, { width: 0, opacity: 0 });
      gsap.set(bullet, { scale: 0, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 80%",
          end: "top 20%",
          toggleActions: "play none none reverse",
        },
      });

      tl.to(card, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power2.out",
      })
        .to(
          line,
          {
            width: "50%",
            opacity: 1,
            duration: 0.5,
            ease: "power2.inOut",
          },
          "-=0.2"
        )
        .to(
          bullet,
          {
            scale: 1,
            opacity: 1,
            duration: 0.4,
            ease: "back.out(1.7)",
          },
          "-=0.1"
        );
    });
  });
});
